export default {
    groupData: {},
    operations: [],
    otherOperations: [],
    departments: [],
    modalContext: {},
    lastGroup: {},
    source: {},
    defaultCurrency: {},
    errors: [],
    method: '',
    returnUrl: '',
    addContractorsUrl: '',
    useExchangeRates: false,
    hasOperationDrafts: false,
    operationDraftsUrl: '',
    statementFiles: {},
    statementPdfUploadUrl: null,
    canAddStatementPdf: false,
    modalCheckboxes: {},
    stateToCommit: {
        operations: [],
        otherOperations: []
    }
}
